document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.ciwt-add');

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const variantId = this.dataset.vid;
      const msg = this.closest('.ciwt-btns').querySelector('.ciwt-msg');

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const alreadyInCart = cart.items.find(
            item => item.id == variantId
          );

          if (alreadyInCart) {
            msg.style.display = 'block';

            setTimeout(() => {
              msg.style.display = 'none';
            }, 5000);

            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(() => {
            window.location.href = '/cart';
          });
        })
        .catch(err => console.error(err));
    });
  });
});